export const saveToDisk = () => {
  const a = document.createElement('a')

  document.body.appendChild(a)
  a.style.display = 'none'

  return (url: string, fileName?: string) => {
    a.href = url
    a.target = '_blank'
    a.download = fileName || 'untitled'
    a.click()
  }
}

export const downloadFileFromUrl = saveToDisk()
